module.exports = __webpack_public_path__ + "static/media/maintenance.d4c93062.png";